import { useCallback, useState } from 'react';

/**
 * Custom hook to manage audit decision panel state
 * Extracted to reduce component complexity
 */
export function useAuditDecisionPanelState() {
  // Action sheet menu state
  const [isActionMenuOpen, setIsActionMenuOpen] = useState(false);
  const actionMenuButtonId = 'audit-decision-actions-button';

  // Validation state for required fields
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const [validationToast, setValidationToast] = useState<string | null>(null);

  // Handle action menu close
  const handleActionMenuClose = useCallback(() => {
    setIsActionMenuOpen(false);
  }, []);

  return {
    isActionMenuOpen,
    setIsActionMenuOpen,
    actionMenuButtonId,
    showValidationErrors,
    setShowValidationErrors,
    validationToast,
    setValidationToast,
    handleActionMenuClose,
  };
}
